import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;

    if (currentUser) {
      // authorised so return true
      // document.body.classList.remove("login-page");
      // document.body.classList.add("sidebar-mini");
      // document.body.classList.add("layout-fixed");
      this.authenticationService.loggedIn.next(true);
      return true;
    }

    this.authenticationService.loggedIn.next(false);
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login']);
    return false;
  }
}
